import { useEffect, useState } from 'react';

const STORAGE_KEY = 'pai-launch-deadline';

function getDeadline(hours: number): number {
  const now = Date.now();
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    if (stored && stored > now) return stored;
    const next = now + hours * 3600 * 1000;
    localStorage.setItem(STORAGE_KEY, String(next));
    return next;
  } catch {
    return now + hours * 3600 * 1000;
  }
}

export function useCountdown(hours: number) {
  const [deadline, setDeadline] = useState(() => getDeadline(hours));
  const [remaining, setRemaining] = useState(() => Math.max(0, deadline - Date.now()));

  useEffect(() => {
    const id = setInterval(() => {
      const diff = deadline - Date.now();
      if (diff <= 0) {
        const next = getDeadline(hours);
        setDeadline(next);
        setRemaining(next - Date.now());
      } else {
        setRemaining(diff);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [deadline, hours]);

  const totalSeconds = Math.floor(remaining / 1000);
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}